<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img alt="login" class="mx-auto" src="@/assets/images/pages/login.png">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-2">{{systemConfig.universityName}}</h4>
                  <h4 class="mb-4">{{ $t('user.login-title') }}</h4>
                  <p class="mb-4">{{ $t('user.login-sub-title') }}</p>
                  <span v-if="requestCount > 1" class="text-danger">Login attemp {{ requestCount - 1 }}</span>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <form>
                      <vs-input
                        v-model="form.username"
                        :label-placeholder="$t('user.username')"
                        class="w-full"
                        name="email"/>

                      <div class="inline-flex w-full align-item-bottom">
                        <vs-input
                          v-model="form.password"
                          :disabled="tempDisableLogin"
                          :label-placeholder="$t('user.password')"
                          autocomplete="off"
                          class="w-full mt-6"
                          name="password"
                          :type="inputPasswordType"
                          @keyup.enter="handleLogin"
                        />
                        <vs-button
                          class="mt-auto ml-1"
                          color="primary"
                          type="flat"
                          icon-pack="feather"
                          :icon="passwordIcon"
                          @click="togglePasswordVisibility"
                        ></vs-button>
                      </div>

                      <!--                    <div class="flex flex-wrap justify-end my-5">-->
                      <!-- <vs-checkbox class="mb-3" v-model="form.rememberMe">{{$t('user.remember-me')}}</vs-checkbox> -->
                      <!--                    <router-link to="/user/forgot-password">{{$t('user.forgot-password-question')}}</router-link>-->
                      <!--                    </div>-->
                      <!-- <vs-button type="border" to="/user/register">{{$t('user.register')}}</vs-button> -->

                      <vs-button
                        :disabled="tempDisableLogin"
                        class="float-right mt-4 mb-5"
                        @click="handleLogin">
                        {{ $t('user.login') }}
                      </vs-button>
                      <!--
                      <vs-divider>{{$t('user.or')}}</vs-divider>
                      <div class="social-login-buttons flex flex-wrap items-center mt-4">
                        <! -- facebook -- >
                        <div class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                          <svg aria-hidden="true" class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9"
                               data-icon="facebook-f" data-prefix="fab"
                               focusable="false" role="img"
                               viewBox="0 0 264 512" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
                              fill="currentColor"></path>
                          </svg>
                        </div>
                        <! -- TWITTER -- >
                        <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                          <svg aria-hidden="true" class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16"
                               data-icon="twitter" data-prefix="fab"
                               focusable="false" role="img"
                               viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                              fill="currentColor"></path>
                          </svg>
                        </div>
                        <! -- GOOGLE -- >
                        <div class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                          <svg aria-hidden="true" class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16"
                               data-icon="google" data-prefix="fab"
                               focusable="false" role="img"
                               viewBox="0 0 488 512" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                              fill="currentColor"></path>
                          </svg>
                        </div>
                        <! -- GITHUB -- >
                        <div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4">
                          <svg aria-hidden="true" class="text-white h-4 w-4 svg-inline--fa fa-github-alt fa-w-15"
                               data-icon="github-alt" data-prefix="fab"
                               focusable="false" role="img"
                               viewBox="0 0 480 512" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                              fill="currentColor"></path>
                          </svg>
                        </div>
                      </div> -->
                    </form>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="flex flex-wrap justify-end">
                      <span style="white-space: pre-wrap;" class="text-right">{{ systemConfig.contactInfo }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import {serverResponseStatusSet} from "@/utils/notification";
import Swal from 'sweetalert2'

import store from '@/store';
import user from '@/store/modules/user';
import systemConfig from '@/store/modules/system/system-config';
import {resolveTenantFromUrl, TENANT_NATION} from '@/utils/tenant';

if (!store.state.user) store.registerModule(`User`, user);
if (!store.state.systemConfig) store.registerModule(`systemConfig`, systemConfig);

const {mapFields: mapUserFields} = createHelpers({
  getterType: `User/getField`,
  mutationType: `User/updateField`,
});
const {mapFields: mapSystemConfigFields} = createHelpers({
  getterType: `systemConfig/getField`,
  mutationType: `systemConfig/updateField`,
});

const {
  mapActions: mapUserActions,
} = createNamespacedHelpers(`User`);
const {
  mapActions: mapSystemConfigActions,
} = createNamespacedHelpers(`systemConfig`);

export default {
  data() {
    return {
      form: {
        // email: "",
        username: "",
        password: "",
        rememberMe: false,
      },
      requestCount: 0,
      cooldoownInterval: null,
      coolDownTimeRemain: 0,
      tempDisableLogin: false,
      contact: {
        line1: '',
        line2: ''
      },
      passwordVisible: false,
      systemConfig: {},
    }
  },
  computed: {
    ...mapUserFields(["currentUser", "processing", "loginError", "loginStatus"]),
    ...mapSystemConfigFields({"systemConfigProcessing": "processing"}),
    coolDownTime() {
      return ((this.requestCount > 5 ? this.requestCount - 5 : this.requestCount) * 10);
    },
    inputPasswordType() {
      return this.passwordVisible ? 'text' : 'password'
    },
    passwordIcon() {
      return this.passwordVisible ? 'icon icon-eye-off' : 'icon icon-eye'
    }
  },
  methods: {
    ...mapUserActions(["login"]),
    ...mapSystemConfigActions(["getSystemConfigWestern", "getSystemConfigNation", "getSystemConfigDemo"]),
    async handleLogin() {
      if (!this.tempDisableLogin) {
        if (this.requestCount < 5) {
          this.requestCount += 1;
          let result = await this.login({
            credential: {
              // email: this.form.email,
              username: this.form.username,
              password: this.form.password
            }, vm: this
          });

          // if have outstanding month then show alert
          if (result) {
            if(Array.isArray(result) && result.length > 0) {
              result = result[0]
            }
            if(result){
              const link = result.linkToXRegis;
              if (result.isOutstanding) {
                let message = '';
                result.outstandingMonth.forEach(e => {
                  message += '<p>'
                    + this.$t('general.time.month')
                    + ' <b>' + e.monthName + '</b>'
                    + ' ' + this.$t('general.time.year')
                    + ' <b>' + e.yearTh + '</b>'
                    + '</p>'
                })

                Swal.fire({
                  title: this.$t('user.you-have-outstanding-balance-title'),
                  icon: 'warning',
                  html: message,
                  confirmButtonText: this.$t('user.go-to-x-regis'),
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.open(link, "_blank");
                  }
                })
              }

              //if have overdue document upload then show alert
              if (result.isStudentDocumentOffLimit) {
                Swal.fire({
                  title: this.$t('user.you-have-document-to-upload-title'),
                  icon: 'warning',
                  html: this.$t('user.you-have-document-to-upload-message'),
                  confirmButtonText: this.$t('user.go-to-x-regis-to-upload'),
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.open(link, "_blank");
                  }
                })
              }
            }
          }

        } else if (this.requestCount >= 5) {
          this.tempDisableLogin = true;
          this.requestCount += 1;
          this.coolDownTimeRemain = this.coolDownTime;

          this.cooldoownInterval = setInterval(() => {
            if (this.coolDownTimeRemain === 0) {
              this.requestCount = 0;
              this.tempDisableLogin = false;
              clearInterval(this.cooldownInterval);
            } else {
              Math.max(this.coolDownTimeRemain -= 1, 0);
            }
          }, 1000);

          this.$store.commit("User/setLoginStatus",
            serverResponseStatusSet(
              "Authentication Error",
              {
                status: {
                  error: true,
                  successa: false,
                  message: "Error too many request.. Please await a few minutes before login again in " + (Math.round(this.coolDownTimeRemain)) + " seconds",
                  code: 429,
                }
              })
          );
        }
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    async initData(){
      if (resolveTenantFromUrl(window.location.href) === TENANT_NATION) {
        this.systemConfig = await this.getSystemConfigNation()
      } else {
        this.systemConfig = await this.getSystemConfigWestern()
        // this.systemConfig = await this.getSystemConfigDemo()
      }

      /*if (window.location.hostname.includes('western')) {
        this.contact = {
          line1: this.$t('user.western-contact-info-line-1'),
          line2: this.$t('user.western-contact-info-line-2')
        }
      } else if (window.location.hostname.includes('nation')) {
        this.contact = {
          line1: this.$t('user.nation-contact-info-line-1'),
          line2: this.$t('user.nation-contact-info-line-2')
        }
      } else {
        this.contact = {
          line1: this.$t('user.western-contact-info-line-1'),
          line2: this.$t('user.western-contact-info-line-2')
        }
      }*/
    },
  },
  watch: {
    currentUser(val) {
      if (val && val.id && val.id.length > 0) {
        setTimeout(() => {
          this.$router.push("/");
        }, 200);
      }
    },
    loginStatus(val) {
      if (val != null) {
        this.$vs.notify({...val});
      }
    }
  },
  async beforeMount() {
    await this.initData();
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
